// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__d8qQs","vLegacy":"SelectSecondary_vLegacy__3Es7i","error":"SelectSecondary_error__3OWsr","disabled":"SelectSecondary_disabled__3YiYB"};